export default __webpack_public_path__ + "images/models/741cba3df847ed9da6b38a9fc85586a9.usdz";